module.exports = __webpack_public_path__ + "img/cliente10.34d89193.jpg";